/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { Integer } from '@belimo-retrofit-portal/logic';

export const INTEGER_ZERO = 0 as Integer;
export const INTEGER_ONE = 1 as Integer;
